export const applyEquipementFilters = (annonce, filters) => {
  const { typeEquipement = [], etat = [], prixMin, prixMax } = filters;

  const isTypeEquipementFiltered =
    typeEquipement.length === 0 ||
    typeEquipement.includes(annonce.typeEquipement);

  const isEtatFiltered =
    etat.length === 0 || etat.includes(annonce.etat);

  const isPrixFiltered =
    (!prixMin || annonce.prix >= parseFloat(prixMin)) &&
    (!prixMax || annonce.prix <= parseFloat(prixMax));

  return isTypeEquipementFiltered && isEtatFiltered && isPrixFiltered;
};
